var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44773 14C9.8014 14 10.1405 13.8595 10.3905 13.6095L13.6095 10.3905C13.8595 10.1405 14 9.80133 14 9.44773V3.33333C14 2.59693 13.4031 2 12.6667 2H3.33333C2.59693 2 2 2.59693 2 3.33333V12.6667C2 13.4031 2.59693 14 3.33333 14H9.44773ZM8.66667 10C8.66667 9.2636 9.2636 8.66667 10 8.66667H13V9.4476C13 9.5368 12.9652 9.62047 12.9023 9.6836L9.6836 12.9023C9.62047 12.9651 9.5368 13 9.4476 13H8.66667V10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.4efa1e23947d550b9e5163ebbacc6c37.svg";
export { ForwardRef as ReactComponent };